/**
 * 判断用户端是否支持storage存储(可以用于判断是否开启了无痕浏览)
 * @returns {boolean}
 */
function isStorageSupported() {
    const testKey = 'test';
    try {
        const storage = window.sessionStorage;
        storage.setItem(testKey, 'testValue');
        storage.removeItem(testKey);
        return true;
    } catch (error) {
        return false;
    }
}

/**
 * 构造函数
 * try包裹的sessionStorage setItem方法
 */
function sessionStorage(this: any) {
    this.setItem = function (key: string, value: any) {
        try {
            window.sessionStorage.setItem(key, value);
        } catch (e) {
            console.log(e);
        }
    };

    this.getItem = function (key: string) {
        try {
            return window.sessionStorage.getItem(key);
        } catch (e) {
            console.log(e);
        }
    };

    this.removeItem = function (key: string) {
        try {
            window.sessionStorage.removeItem(key);
        } catch (e) {
            console.log(e);
        }
    };
}

/**
 * 构造函数
 * try包裹的localStorage setItem方法
 */
function localStorage(this: any) {
    this.setItem = function (key: string, value: any) {
        try {
            window.localStorage.setItem(key, value);
        } catch (e) {
            console.log(e);
        }
    };

    this.getItem = function (key: string) {
        try {
            return window.localStorage.getItem(key);
        } catch (e) {
            console.log(e);
        }
    };

    this.removeItem = function (key: string) {
        try {
            window.localStorage.removeItem(key);
        } catch (e) {
            console.log(e);
        }
    };
}

export default {
    localStorage: new (localStorage as any)(),
    sessionStorage: new (sessionStorage as any)(),
    isStorageSupported,
};
